import theme from "theme";

import Box from "components/Box";

import ProjectTable from "entities/Deal/components/OverviewProject/ProjectTable";
import { IDeal } from "entities/Deal/sdk";
import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";
import { IMemoSection } from "entities/Memo/sdk";

import PrintableProjectImage from "./PrintableProjectImage";

interface IPrintableSectionProjectDetails {
  deal: IDeal;
  sectionName?: string;
  section?: IMemoSection;
  externalToken?: string;
}

const PrintableSectionProjectDetails = ({
  deal,
  sectionName = "",
  section,
  externalToken,
}: IPrintableSectionProjectDetails) => (
  <Box>
    <SectionHeader
      label={section?.title || sectionName}
      alignActionButton={section ? "right" : "left"}
    />
    <SectionContent>
      <Box sx={{ marginBottom: theme.spacing(2) }}>
        <ProjectTable deal={deal} externalToken={externalToken} />
      </Box>
      <PrintableProjectImage deal={deal} />
    </SectionContent>
  </Box>
);

export default PrintableSectionProjectDetails;
